import { ActionIcon, ActionIconProps } from "@mantine/core";
import { createLink } from "@tanstack/react-router";
import { forwardRef, ReactNode } from "react";

type ActionIconLinkProps = {
    icon: ReactNode;
} & ActionIconProps;

const MantineActionIconLink = forwardRef<HTMLAnchorElement, ActionIconLinkProps>((props, ref) => (
    <ActionIcon component="a" ref={ref} {...props}>
        {props.icon}
    </ActionIcon>
));

export const ActionIconLink = createLink(MantineActionIconLink);
